import { render, staticRenderFns } from "./Document.vue?vue&type=template&id=60888d27&scoped=true"
import script from "./Document.vue?vue&type=script&lang=js"
export * from "./Document.vue?vue&type=script&lang=js"
import style0 from "./Document.vue?vue&type=style&index=0&id=60888d27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60888d27",
  null
  
)

export default component.exports